import { render, staticRenderFns } from "./group_skills_popup.vue?vue&type=template&id=0fbad722&scoped=true"
import script from "./group_skills_popup.vue?vue&type=script&lang=js"
export * from "./group_skills_popup.vue?vue&type=script&lang=js"
import style0 from "./group_skills_popup.vue?vue&type=style&index=0&id=0fbad722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbad722",
  null
  
)

export default component.exports